import { Component, OnInit } from '@angular/core';
import { ModulesService, LoadingService, PermissionsService, SessionService, UtilsService, UserService } from '@services/index.service';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileComponent } from '@shared/index.shared';
import { environment } from '@environments/environment';
import { AngularPaths, Permission, UserData } from '@models/index.model';
import { Module } from '@models/index.model';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  public theme: string = environment.THEME;
  public angularPaths = AngularPaths;
  public tooltipTitle: string;
  // NAV CONFIG
  public navOpen: boolean = false;
  public defaultPath: AngularPaths = AngularPaths.SIGNTRUST;
  // USER ACCESS
  public hasCertificatesAccess: boolean = false;
  public hasSignaturesAccess: boolean = false;
  public hasWebSignAccess: boolean = false;
  public changeUserDataAccess: boolean = false;
  //USER DATA
  public userData: UserData;

  public constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    public _utils: UtilsService,
    private _permiss: PermissionsService,
    private _modules: ModulesService,
    private _session: SessionService,
    private _loading: LoadingService,
    private _user: UserService
  ) {
    this.theme = this._utils.titleCaseWord(this.theme);
    translate.get(['GLOBAL.TOOLTIP']).subscribe(res => {
      this.tooltipTitle = res['GLOBAL.TOOLTIP'];
    });
  }

  public ngOnInit() {
    this.userData = this._user.getUserDataFromLocalStorage();
    this.hasSignaturesAccess = this._permiss.hasPermiss(Permission.DOCUMENT_SIGNATURE);
    this.changeUserDataAccess = this._permiss.hasAnyPermiss(
      Permission.CHANGE_PASSWORD,
      Permission.CHANGE_NAME,
      Permission.CHANGE_EMAIL
    );
    this.hasCertificatesAccess = true;
    this.hasWebSignAccess = this._modules.hasModule(Module.WEB_SIGNATURE) && this._permiss.hasPermiss(Permission.WEB_SIGNATURE);
  }

  public onLogout() {
    this._loading.showGlobalLoading();
    this._session
      .removeSession()
      .pipe(finalize(() => this._loading.hideGlobalLoading()))
      .subscribe();
  }

  public openUserProfile() {
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '600px',
      data: {},
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(_ => {
      this.userData = this._user.getUserDataFromLocalStorage()
    });
  }
}
